import Vue from 'formVueLp1a';

new Vue({
  el: '.l-wrapper'
});
